import React, { ChangeEvent, FunctionComponent, useEffect, useRef, useState } from 'react';
import { Checkbox, CustomScrollbar, CustomScrollbarRef, isMobileDevice, isTabletDevice, Text } from 'rs-emd-ui-atoms';
import { getLabel } from '../../../../helpers/html.utils';
import { ILabel } from '../../../../models/common/label.model';
import { IFacet } from '../../../../models/plp/plp-facets.model';
import { OrderedFilter } from '../filters';
import styles from './filter-list-component.module.scss';

type FilterListProps = {
  labels?: ILabel[] | null;
  facet: IFacet;
  isVisible?: boolean;
  selectedFilters: OrderedFilter[];
  updateSelection: (id: string, keys: (string | number)[]) => void;
};

export const FilterList: FunctionComponent<FilterListProps> = (props: FilterListProps) => {
  const ps = useRef<CustomScrollbarRef | null>();
  const [values, setValues] = useState(props.facet.values);

  useEffect(() => {
    // call update scroll to re-calculate scroll length
    ps.current?.updateScroll();
  }, [props.isVisible]);

  // update values if prop changes
  useEffect(() => {
    setValues(props.facet.values);
  }, [props.facet.values]);

  return (
    <div className={styles['filter-list-container']}>
      {props.facet.values.length > 20 && (
        <Text
          autoFocus={true}
          placeholder={getLabel(props.labels, 'filters_search').replace('[filter_name]', props.facet.displayName)}
          icon='search'
          className={styles.search}
          background='white'
          onChange={(e) => onTextboxChange(e)}></Text>
      )}
      <CustomScrollbar
        showOnLoad={true}
        ref={(el: any) => (ps.current = el)}
        className={styles.list}
        width={values.length > 20 ? 'thick' : 'default'}
        showYButtons={values.length > 20 && !isMobileDevice() && !isTabletDevice()}>
        {values.length === 0 && <p className={styles['no-results']}>{getLabel(props.labels, 'filters_no_matches')}</p>}
        <Checkbox
          inline={false}
          name={props.facet.displayName}
          className={styles.filters}
          selectCallback={(keys) => props.updateSelection(props.facet.id, keys)}
          defaultSelection={props.selectedFilters
            .filter((f) => f.id === props.facet.id)
            .map((f) => {
              return f.filter.id;
            })}
          list={values.map((f) => {
            return {
              key: f.id,
              elt: (
                <span>
                  {f.displayValue} ({f.resultsCount})
                </span>
              ),
            };
          })}
        />
      </CustomScrollbar>
      {props.selectedFilters.filter((f) => f.id === props.facet.id).length > 0 && (
        <button className={`link ${styles.clear}`} onClick={() => props.updateSelection(props.facet.id, [])}>
          {getLabel(props.labels, 'filters_clear')} ({props.selectedFilters.filter((f) => f.id === props.facet.id).length})
        </button>
      )}
    </div>
  );

  function onTextboxChange(e: ChangeEvent<HTMLInputElement>) {
    let searchText = e.currentTarget.value.toLowerCase().replace(/\s/g, '');
    setValues(
      searchText.length > 0
        ? props.facet.values.filter((v) => v.displayValue?.toLowerCase().replace(/\s/g, '')?.includes(searchText))
        : props.facet.values
    );
  }
};
